import isElementExist from './helpers/isElementExist.js';
import medicationChoice from './modules/medicationChoice';
import singleMedicationChoice from './modules/singleMedicationChoice';

window.addEventListener('DOMContentLoaded', () => {
  isElementExist('.medications-box', medicationChoice);
  isElementExist('#landing-productbtn', singleMedicationChoice);
});
